<template>
    <v-select v-model="query['_member']" prefix="회원" placeholder="본인" outlined hide-details clearable v-bind="{ items }" @change="emit" />
</template>

<script>
import api from "@/api";

const initQuery = (form = {}) => ({
    ...(form || {}),
    ["_member"]: form?.["_member"] || null,
});

export default {
    data: () => ({
        query: initQuery(),

        /** @type {Awaited<ReturnType<typeof api.v1.me.codes.descendants.members.gets>>['members']} */
        members: [],

        loading: false,
    }),
    computed: {
        items() {
            return this.members.map((item) => ({
                text: `${item.name} (${item.username})`,
                value: item._id,
            }));
        },
    },
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            let { ...query } = this.query;

            delete query.page;

            if (!query["_member"]) delete query["_member"];

            this.$router.push({ query });
        },

        async init() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { members } = await api.v1.me.codes.descendants.members.gets();
                this.members = members;
            } finally {
                this.loading = false;
            }
        },
    },
    watch: {
        "$route.query"() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
        this.init();
    },
};
</script>

<style lang="scss" scoped></style>
